import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { api_url } from "../config/config";

const EditStore = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { branch } = location?.state || {}; 
  const [branchName, setBranchName] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [locationUrl, setLocationUrl] = useState("");

  useEffect(() => {
    if (branch) {
      setBranchName(branch.area || "");
      setAddress(branch.branch_address || "");
      setPincode(branch.pincode || "");
      setContactNumber(branch.contact_number || "");
      setLocationUrl(branch.location || "");
    }
  }, [id, branch]);

  const validateForm = () => {
    if (pincode && !/^\d{6}$/.test(pincode)) {
      alert("Please enter a valid 6-digit pincode");
      return false;
    }
    if (contactNumber && !/^\d{10}$/.test(contactNumber)) {
      alert("Please enter a valid 10-digit contact number");
      return false;
    }
    return true;
  };

  const updateBranch = async () => {
    if (!validateForm()) return;

    const payload = {
      area: branchName,
      branch_address: address,
      pincode,
      contact_number: contactNumber,
      location: locationUrl,
    };

    try {
      const response = await fetch(`${api_url}/branch/${id}`, {
        method: "PATCH",
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("admin_token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        await response.json();
        alert("Store details successfully updated!");
        navigate("/ng-admin/branches");
      } else {
        const error = await response.json();
        alert(error.message || "Failed to update store. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while updating the store. Please try again.");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-semibold mb-3">Edit Store</h2>

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Store Information</h2>

              {/* Branch Name */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Branch Name
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  value={branchName}
                  onChange={(e) => setBranchName(e.target.value)}
                  required
                />
              </div>

              {/* Address */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Address
                </label>
                <textarea
                  className="w-full border border-gray-300 rounded-lg p-3"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              {/* Pincode */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Pincode
                </label>
                <input
                  type="text"
                  maxLength="6"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value.replace(/\D/g, ""))}
                />
              </div>

              {/* Contact Number */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Contact Number
                </label>
                <input
                  type="text"
                  maxLength="10"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  value={contactNumber}
                  onChange={(e) =>
                    setContactNumber(e.target.value.replace(/\D/g, ""))
                  }
                />
              </div>

              {/* Location */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Google Maps Location URL
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  value={locationUrl}
                  onChange={(e) => setLocationUrl(e.target.value)}
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  className="px-6 py-3 bg-[#3C1F1F] text-white font-semibold rounded-lg shadow-md"
                  onClick={updateBranch}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStore;
